// sections

import OverlayCreateView from 'src/sections/admin/overlays/view/overlay-create-view';

export default function CreateOverlayPage() {
  return <OverlayCreateView />;
}
